import axios from "axios";
import moment from "moment";
import ethLogo from '../assets/images/etherscan-logo.svg';
import link1Logo from '../assets/images/link1.png';
import link2Logo from '../assets/images/link2.png';
import link3Logo from '../assets/images/link3.png';


export const trimAddress = (addr) => {
  return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
}

export const contract = {
  56: {
    MULTICALL_ADDRESS: "0xcf591ce5574258ac4550d96c545e4f3fd49a74ec",
    NFT_ADDRESS: "0xAf3ea19779C6B6684593B65AFbDD75A61e4d0d23",
    STAKE_ADDRESS: "0x3b457ddcdd79c10a599ae09ceb0302858a04ef1a",
    TOKEN_ADDRESS: "0x67Db74b6D1Ea807CB47248489c99D144323D348d",
    ROUTER_ADDRESS: "0x131a98c17FBace26Bf23c9ba62867a4E84E03E96",
    PAIR_ADDRESS: "0x0f7b2aefa0bec05c0a3f00e0bb6d29514063fded",
    USDT_ADDRESS: "0x55d398326f99059ff775485246999027b3197955",
    WETH: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
  },
  97: {
    MULTICALL_ADDRESS: "0xa54fe4a3dbd1eb21524cd73754666b7e13b4cb18",
    NFT_ADDRESS: "0xff9830a44d98cdd90492c4af010be28da2b64654",
    STAKE_ADDRESS: "0x95a70968733ae645606a3d80a37ef92041d70c5b",
    TOKEN_ADDRESS: "0xf4A880A6267B163e75804CaC7Fd7B8C1106bC00E",
    ROUTER_ADDRESS: "0x463df7b0a06f3d06c41ba6549787ccf9e4c93d24",
    PAIR_ADDRESS: "0x5fff7742c714ea69f6439d19a5629876cff0ad3e",
    USDT_ADDRESS: "0xC28112C2EC55aE1F15b78b51FC101b80eD1d529E",
    WETH: "0x55d398326f99059ff775485246999027b3197955"
  }
}

export const EXPLORE_URL = "https://bscscan.com"
export const DEFAULT_CHAIN = 56;
// export const RPC = "https://data-seed-prebsc-1-s1.bnbchain.org:8545";
export const RPC = "https://bsc-dataseed1.bnbchain.org";
export const DECIMALS = 8;
export const URI_PREFIX = 'https://alchemy.mypinata.cloud/ipfs/';
export const NFT_SYMBOL = "MGPLOTTER";
export const TOKEN_SYMBOL = "MCOIN";
export const PROJECT_ID = '27b9720018bf7f8740936e6a6eb28604';
export const MORALIS_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjY3NGRhM2QwLTJlYTUtNGRhNy1hNjljLTg1MTNjMDE0YmZhOCIsIm9yZ0lkIjoiNDY1NDg1IiwidXNlcklkIjoiNDc4ODg1IiwidHlwZUlkIjoiNjM1YTliZjYtYjY2ZS00Y2E5LTljZmMtYjA0YTY4YzA2NjZiIiwidHlwZSI6IlBST0pFQ1QiLCJpYXQiOjE3NTUzNTYxOTMsImV4cCI6NDkxMTExNjE5M30.rq-lufGv0S7vEVcPZ7AqTcGOZ6JQzaQDaYA3ms7_Fhs';
export const MORALIS_BASE_URL = "https://deep-index.moralis.io/api/v2.2/";
export const MORALIS_CHAIN_NAME = 'bsc'
// export const MORALIS_CHAIN_NAME = '0x61'
// export const BACKEND_URL = "https://mining.devcodesaga.tech";
export const BACKEND_URL = "https://mgp-lotter.com/admin";
// export const BACKEND_URL = "http://localhost/mgp-lotto-nft-backend";
// export const BACKEND_URL = "http://localhost/ricesnetwork";




export const formatDate = (unixTime) => {
  try {
    let dateString = moment(unixTime).format('lll');
    return dateString;
  }
  catch (err) {
    console.log(err.message);
  }
}

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`, // Assuming your API routes are prefixed with /api
  headers: {
    'Content-Type': 'application/json',
  }
});

export const stakePeriod = ["360 day"];


export const daysLeftFromTimestamp = (timestamp) => {
  // Get the current date and time
  const currentDate = new Date();

  // Parse the given timestamp
  const targetDate = new Date(timestamp);

  // Calculate the difference in time (in milliseconds)
  const timeDifference = targetDate - currentDate;

  // Convert the time difference from milliseconds to days
  const millisecondsInADay = 1000 * 60 * 60 * 24;
  const daysLeft = Math.ceil(timeDifference / millisecondsInADay);

  return daysLeft;
}

export const extractRevertReason = (error) => {
  const raw = error?.reason || error?.message || "Transaction failed";

  // Remove the 0x-prefixed ABI-encoded part if it exists
  const cleaned = raw.split("0x")[0]?.trim();

  return cleaned.endsWith(":") ? cleaned.slice(0, -1).trim() : cleaned;
}


export const menuItems = [
  {
    name: 'Home',
    url: '/',
    external: false,
    icon: 'fa-solid fa-home',
    image: null,
    isMobile: true
  },
  {
    name: 'My NFTs',
    url: '/my-nft',
    external: false,
    icon: 'fa-solid fa-desktop',
    image: null,
    isMobile: true
  },
  {
    name: 'Staked NFTs',
    url: '/staked',
    external: false,
    icon: 'fa-solid fa-box-open',
    image: null,
    isMobile: true
  },
  {
    name: 'Marketplace',
    url: '#sec',
    external: true,
    icon: 'fa-solid fa-warehouse',
    image: null,
    isMobile: false
  },
  {
    name: 'Exchange',
    url: ' https://mgpswap.com/',
    external: true,
    icon: 'fa-solid fa-globe',
    image: null,
    isMobile: false
  },
  {
    name: 'Contract',
    url: 'https://bscscan.com/token/0x154d91190b442f6eF880ED1bAEF6bd04E34659C2',
    external: true,
    icon: null,
    image: ethLogo,
    isMobile: false
  },
  {
    name: 'Chart',
    url: 'https://www.dextools.io/app/en/bnb/pair-explorer/0xee36ab9e6042b7755e2555eaceda5793008da0b1?t=1719031181133',
    external: true,
    icon: 'fa-solid fa-globe',
    image: null,
    isMobile: false
  },
  {
    name: 'MCOIN Saving',
    url: 'https://saving-mmsc.com/',
    external: true,
    icon: null,
    image: link3Logo,
    isMobile: false
  },
  {
    name: 'MCASH Saving',
    url: 'https://mcash-saving.com/',
    external: true,
    icon: null,
    image: link1Logo,
    isMobile: false
  },
  {
    name: 'MCASH Mining(V1)',
    url: 'https://mgp-platform.com/',
    external: true,
    icon: null,
    image: link1Logo,
    isMobile: false
  },
  {
    name: 'MCASH Mining(V2)',
    url: 'https://mgp-mining.com/',
    external: true,
    icon: null,
    image: link2Logo,
    isMobile: false
  }
];

